<template>
	<div class="drawer">
		<el-drawer size="650px" :visible.sync="drawerStatus" @close='close' :title="'员工资产查询'" :wrapperClosable="false"  >

			<el-form :inline="true" class="form">
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="8" >
						<el-form-item label="编号:" :label-width="formLabelWidth" >
							{{info&&info.assetsCode}}
						</el-form-item>
					</el-col>
					<el-col :span="8" >
						<el-form-item label="名称:" :label-width="formLabelWidth" >
							{{info&&info.assetsName}}
						</el-form-item>
					</el-col>
					<el-col :span="8" >
						<el-form-item label="规格:" :label-width="formLabelWidth" >
							{{info&&info.skuName}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="8" >
						<el-form-item label="所在位置:" :label-width="formLabelWidth" >
							{{info&&info.position}}
						</el-form-item>
					</el-col>
					<el-col :span="8" >
						<el-form-item label="负责数量:" :label-width="formLabelWidth" >
							{{info&&info.stockInfo.reality}}
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div v-show="info?info.stockInfo.lock:''">
				<div style="font-size: 16px;font-weight:600;padding:0 10px;margin: 20px;">锁定信息</div>
				<div style="font-size: 13px;border: 1px solid;margin: 5px;padding: 8px;" v-for="(item,index) in lockList" :key="index">
					<div style="display: flex;justify-content: space-between;margin:10px;">
						<span>申请时间:{{item.createOperationInfo.operationTime}}</span><span style="color: orange;cursor: pointer;">{{item.processType.name}}</span>
					</div>
					<div style="margin: 10px;">交接人:{{item.receiveInfo.name||''}}</div>
					<div style="margin: 10px;">交接数量:{{item.assetsInfo.length}}</div>
				</div>
				<!-- <div style="font-size: 13px;border: 1px solid;margin: 5px;padding: 8px;">
					<div style="display: flex;justify-content: space-between;margin:10px;">
						<span>申请时间:</span><span style="color: orange;">报废</span>
					</div>
					<div style="margin: 10px;">报废数量:</div>
				</div> -->
			</div>
			<div style="height: 40px;width:100%;"></div>
			<div class="btnBox">
				<div class="btnItem" @click="close">取消</div>
				<div class="btnItem submit" @click="close">确定</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				formLabelWidth:'80px',
				detail:{},
				lockList: []
			}
		},
		computed:{
			
		},
		props:{
			info:{
				default:{}
			}
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
			})
			if(this.info.stockInfo.lock){
				let loading = this.$loading();
				let params = {
					'staffId': this.info.staffInfo.id,
					'assetsCode': this.info.assetsCode,
				};
				this.$http.get(process.env.VUE_APP_zichan + '/api/AssetsHandover/assetsList', params).then(res => {
					loading.close()
					if (res.code == 0) {
						// console.log('锁定详情', res)
						this.lockList = res.data;
					}
				})
			}
			
		},
		methods: {
			close(){
				this.$emit('submit',{type:'close'})
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.el-drawer__body{
				overflow: auto;
			}
			.form{
				::v-deep .el-form-item{
					margin:5px 0;
					
				}
				
			}
		}
		
	}
	.imgView{
		flex: 1;
		.imgItem{
			position: relative;
			width: 80px; 
			height: 80px;
			margin-right:20px;
			margin-bottom: 10px;
			float: left;
			img{
				width: 100%;
				height: 100%;
			}
			.closeBtn{
				display: block;
				color: red;
				position: absolute;
				top: -10px;
				right: -10px;
				font-size: 20px;
				z-index: 5;
			}
		}
	}
	.btnBox{
		width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
		.btnItem{
			text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
			&.submit{
				background-color: $mainColor;
			}
		}
	}
</style>
